import DefaultLayout from "@component/Layout/Default"
import { HeaderAntBreadCrumb } from "@component/Layout/HeaderAntBreadCrumb"
import { useAppDispatch } from "@hook/useAppDispatch"
import { changePageTitleAction } from "@reducer/common.reducer"
import { trans } from "@resources/localization"
import { InfoProduct } from "./InfoProduct"
import React, { useEffect, useState } from "react"
import { Tabs } from "antd"
import { PropertiesList } from "./PropertiesList"
import { ListGroups } from "./Groups"
import { useParams } from "react-router-dom"
import { AccessDenied } from "@component/AccessDenied"
import SecurityService from "@util/SecurityService"
import { COMBO_SCOPE } from "@config/permission"
import { filter } from "lodash"
import { Notfound } from "@component/Notfound"
import { callGetDetailSkuCombo } from "@reducer/version2/skuCombo-detail.reducer"
import { callGetComboCategories } from "@reducer/version2/categories.reducer"
import { callGetVendorSuggest } from "@reducer/version2/vendor.reducer"

export const DetailSkuCombo: React.FC = () => {
    const dispatch = useAppDispatch()
    const { id } = useParams()
    const [statusShow, setStatusShow] = useState<number>(0)

    useEffect(() => {
        dispatch(changePageTitleAction(trans("skuCombo.detail_title")))
        dispatch(callGetComboCategories())
    }, [dispatch])

    useEffect(() => {
        if (id) {
            dispatch(callGetDetailSkuCombo(id)).then((result: any) => {
                setStatusShow(result?.payload?.response?.status)
                dispatch(callGetVendorSuggest({ codeOrName: result?.payload?.data?.vendorCode }))
            })
        }
    }, [dispatch])

    const LIST_TAB = [
        { label: trans("telesales.group"), key: "group", children: <ListGroups />, disabled: !SecurityService.can(COMBO_SCOPE.COMBO_GROUP_VIEW) },
        { label: trans("products.properties"), key: "properties", children: <PropertiesList />, disabled: false },
    ]

    const COMBO_BREADCRUMB = [
        { name: trans("sidebar.dashboard"), link: "/" },
        { name: trans("skuCombo.title"), link: "/product?tab=skuCombo" },
        { name: "skuCombo.detail_title" },
    ]

    return (
        <DefaultLayout loading={false}>
            {statusShow === 403 && <AccessDenied />}
            {statusShow === 404 && <Notfound />}
            {![403, 404].includes(statusShow) && (
                <>
                    <HeaderAntBreadCrumb breadCrumbs={COMBO_BREADCRUMB} />
                    <InfoProduct />
                    <Tabs
                        className="nav-space nav-space-x"
                        defaultActiveKey={SecurityService.can(COMBO_SCOPE.COMBO_GROUP_VIEW) ? "group" : "properties"}
                        items={filter(LIST_TAB, { disabled: false })}
                    />
                </>
            )}
        </DefaultLayout>
    )
}
